import React from 'react';
import { Link } from 'react-router-dom';

const BadRequestPage = () => {
  return (
    <div className="error-page">
      <h1>400 Bad Request</h1>
      <p>Sorry, but your request could not be processed due to a bad request. Please check your input and try again.</p>
      <Link to="/">Go back to Home</Link>
    </div>
  );
};

export default BadRequestPage;
